import Cookies from '@/services/cookies'

export default {
  getAll: (state, getters, rootState, rootGetters) => {
    return state.allCities
  },

  getActive: (state, getters, rootState, rootGetters) => {
    return state.active
  },

  getConfirmed: state => Cookies.get('city_confirmed'),

  isOtherCityMode: state => state.otherCityMode,

  isRegion: (state, getters) => {
    let cityId = getters.getActive.id
    if (!cityId) {
      const defaultCityAlias = getters.getCityAliasFromCookie
      if (defaultCityAlias) {
        cityId = getters.getAll.find(
          item => item.alias === defaultCityAlias,
        ).id
      } else {
        cityId = 2
      }
    }
    return ![1, 2].includes(cityId)
  },

  getCityAliasFromCookie: (state) => {
    const alias = Cookies.get('default_city')
    const allAliases = Object.values(state.allCities).map(city => {
      return city.alias
    })
    if (alias && allAliases.includes(alias)) {
      return alias
    }
    return null
  },
}
